export const THAI_REGEX = /[\u0E00-\u0E7F]/g;
export const ENGLISH_REGEX = /[A-Za-z]/g;
